// Enterprise-Grade API Configuration - Updated for centralized architecture
import { API_CONFIG as NEW_API_CONFIG, ENV_CONFIG as NEW_ENV_CONFIG } from './config/ApiConfig';

// Legacy API Configuration for backward compatibility
export const API_CONFIG = {
  BASE_URL: NEW_API_CONFIG.baseURL,
  VERSION: 'v1',
  TIMEOUT: NEW_API_CONFIG.timeout,
  ENDPOINTS: {
    // AI Services
    AI_CHAT: NEW_API_CONFIG.aiEndpoints.chat,
    AI_VOICE_COMMAND: NEW_API_CONFIG.aiEndpoints.voiceCommand,
    AI_CHAT_SIMPLE: NEW_API_CONFIG.aiEndpoints.chatSimple,

    // Document Management
    DOCUMENTS: NEW_API_CONFIG.documentEndpoints.documents,
    DOCUMENTS_MEMOS: NEW_API_CONFIG.documentEndpoints.memos,
    DOCUMENT_INTELLIGENCE: NEW_API_CONFIG.documentEndpoints.intelligence,
    DOCUMENT_ANALYSIS: NEW_API_CONFIG.documentEndpoints.analysis,

    // Case Management
    CASES: NEW_API_CONFIG.caseEndpoints.cases,
    CASE_ROUTES: NEW_API_CONFIG.caseEndpoints.caseRoutes,

    // Client Management
    CLIENTS: NEW_API_CONFIG.clientEndpoints.clients,
    CLIENT_ROUTES: NEW_API_CONFIG.clientEndpoints.clientRoutes,

    // Task Management
    TASKS: NEW_API_CONFIG.taskEndpoints.tasks,
    TASK_ROUTES: NEW_API_CONFIG.taskEndpoints.taskRoutes,

    // Email Services
    EMAIL_ACCOUNTS: NEW_API_CONFIG.emailEndpoints.accounts,
    EMAIL_ROUTES: NEW_API_CONFIG.emailEndpoints.routes,
    GMAIL: NEW_API_CONFIG.emailEndpoints.gmail,

    // Whiteboard Services
    WHITEBOARDS: NEW_API_CONFIG.whiteboardEndpoints.whiteboards,
    WHITEBOARD_TEMPLATES: NEW_API_CONFIG.whiteboardEndpoints.templates,

    // Authentication
    AUTH: NEW_API_CONFIG.authEndpoints.login,
    AUTH_ROUTES: NEW_API_CONFIG.authEndpoints.login,

    // System Services
    HEALTH: NEW_API_CONFIG.endpoints.health,
    SYSTEM: NEW_API_CONFIG.endpoints.system,
    DASHBOARD: NEW_API_CONFIG.endpoints.dashboard,

    // Calendar Services
    CALENDAR: NEW_API_CONFIG.calendarEndpoints.calendar,
    GOOGLE_CALENDAR: NEW_API_CONFIG.calendarEndpoints.googleCalendar,

    // Notifications
    NOTIFICATIONS: NEW_API_CONFIG.endpoints.notifications,

    // Admin Services
    ADMIN: NEW_API_CONFIG.endpoints.admin,
    SUPER_ADMIN: NEW_API_CONFIG.endpoints.superAdmin,

    // Analytics
    ANALYTICS: NEW_API_CONFIG.endpoints.analytics,
    PERFORMANCE: NEW_API_CONFIG.endpoints.performance,

    // Security
    SECURITY: NEW_API_CONFIG.endpoints.security,
    AUDIT: NEW_API_CONFIG.endpoints.audit,
  },

  // Enterprise Security Headers
  SECURITY_HEADERS: NEW_API_CONFIG.headers,

  // Retry Configuration
  RETRY: {
    MAX_ATTEMPTS: NEW_API_CONFIG.retryAttempts,
    DELAY: NEW_API_CONFIG.retryDelay,
    BACKOFF_MULTIPLIER: 2,
  },

  // Feature Flags
  FEATURES: NEW_API_CONFIG.features,
};

// Calendar Configuration
export const CALENDAR_CONFIG = {
  // Google Calendar API
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,

  // Microsoft Calendar API
  MICROSOFT_CLIENT_ID: process.env.REACT_APP_MICROSOFT_CLIENT_ID,

  // Sync intervals (in milliseconds)
  SYNC_INTERVAL: 5 * 60 * 1000, // 5 minutes
};

// Environment Configuration
export const ENV_CONFIG = NEW_ENV_CONFIG;

// Legacy support for backward compatibility
export const API_BASE_URL = API_CONFIG.BASE_URL;
